// DO NOT CHANGE DEFAULT VALUE
export const version = "1.3.7-dev";
